import React from 'react';
import { FaQuestionCircle } from 'react-icons/fa';

/**
 * Icono ? con ayuda contextual (tooltip nativo).
 */
export default function ContextHelp({ text, label = 'Más información' }) {
  if (!text) return null;

  return (
    <button
      type="button"
      className="inline-flex shrink-0 items-center justify-center rounded-full p-0.5 text-e0e3-muted hover:text-e0e3-accent focus:outline-none focus:ring-2 focus:ring-e0e3-accent/40"
      title={text}
      aria-label={label}
    >
      <FaQuestionCircle className="h-3.5 w-3.5" aria-hidden />
    </button>
  );
}
